import React, { useContext, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import RequiredIcon from '../../../assets/icons/astrik.svg';
import RequiredIconRed from '../../../assets/icons/astrik-red.svg';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useColumnOrder } from '@/hooks/useColumnOrder';

const Icon = styled.img``;

const DropdownContainer = styled.div`
  position: absolute;
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  pointer-events: auto;
`;
const OverlayContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const CustomDropdown = styled(Dropdown)`
  &.css-1rr7thl-container,
  &.css-1rr7thl-container:hover {
    height: 100% !important;
    min-height: 100% !important;
    border: ${({ required }) =>
      `${required ? '1px solid #D83A52' : '1px solid #c5c7d0'}`};
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-1m5qxwu-control,
  .css-10r9mp0-control {
    min-height: ${({ height }) => height - 2 + 'px'} !important;
    height: ${({ height }) => height - 2 + 'px'} !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-sv93zi {
    height: ${({ height }) => height - 2 + 'px'} !important;
    position: static;
    padding: 0px !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-1m5qxwu-control {
    align-items: start;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-3qraca {
    height: ${({ height }) => height - 5 + 'px'} !important;
    width: ${({ height }) => height - 5 + 'px'} !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-1uhsr37-indicatorContainer,
  .css-1f6vjyo-indicatorContainer,
  .css-1ipxvlx-indicatorContainer {
    height: ${({ height }) => height - 5 + 'px'} !important;
    width: ${({ height }) => height - 5 + 'px'} !important;
    margin: 0px 5px 0px 0px;
    align-items: center;
    color: ${({ required }) =>
      `${required ? '#D83A52' : '#676879'}`} !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-c9pdm4,
  .egiTEj .css-sv93zi {
    height: ${({ height }) => height - 2 + 'px'} !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-1akzy3l-singleValue,
  .css-5e1yn8-singleValue {
    font-size: ${({ fontSize }) => fontSize + 'px'} !important;
    line-height: ${({ fontSize }) => fontSize + 'px'} !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-n2wxqq-placeholder {
    font-size: ${({ fontSize }) => fontSize + 'px'} !important;
    line-height: ${({ fontSize }) => fontSize + 'px'} !important;
    color: ${({ required }) => `${required ? '#D83A52' : '#676879'}`};
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-18xr5ym {
    font-size: ${({ fontSize }) => fontSize + 'px'} !important;
    line-height: ${({ fontSize }) => fontSize + 'px'} !important;
    margin: 0px !important;
    padding: 0px !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
  .css-1gl4k7y,
  .css-1iokrea-option,
  .css-si1zft-option,
  .css-34fls1-menu {
    font-size: 9px !important;
    line-height: 9px !important;
    background: ${({ color }) => (color ? color : '')} !important;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: ${({ rightPadding }) => rightPadding + 'px'};
  z-index: 0;
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
`;

const DropdownPreviewOverlayChip = ({ x, y, item, from, options = [], showColor }) => {
  const { addedFormFields, updateFormFields } = useContext(FileContext);
  const [isRequired, setIsRequired] = useState(false);
  const { rgbMapper } = useColumnOrder();
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? rgbMapper[itemColor] ?? itemColor
    : '#E6E6FA';

  const dropdownOptions = useMemo(() => {
    if (Array.isArray(item?.options) && item.options.length > 0) {
      return item.options.map((opt) =>
        typeof opt === 'string' ? { label: opt, value: opt } : opt,
      );
    }
    return options;
  }, [options, item?.options]);

  const handleDropdownSelect = (value) => {
    if (from !== '/sign') return;
    const selectedItem = addedFormFields.find((x) => x.id === item.id);
    selectedItem.content = value?.value || value?.label || null;
    selectedItem.hasError = false;
    updateFormFields([...addedFormFields]);
    setIsRequired(false);
  };

  useEffect(() => {
    if (item.hasError) {
      setIsRequired(true);
    }
  }, [addedFormFields, item.hasError]);
  const noPadding = item.noPadding || false;
  const padding = noPadding ? 0 : 7;

  const fontSize = item.fontSize || 11 ;
  return (
    <>
      <DropdownContainer
        x={x+padding}
        y={y+padding}
        height={item.height}
        width={item.width}
      >
        <OverlayContainer height={item.height}>
          <CustomDropdown
            clearable={item.required ? false : true}
            searchable={false}
            height={item.height}
            fontSize={fontSize}
            required={isRequired}
            options={dropdownOptions}
            size={Dropdown.size.SMALL}
            placeholder={item?.column?.label}
            color={showColor ? backgroundColor : ''}
            onChange={handleDropdownSelect}
          ></CustomDropdown>
          <Overlay rightPadding={item.height + 5}>
            {item.required ? (
              <Icon
                src={isRequired ? RequiredIconRed : RequiredIcon}
                alt=""
                height={fontSize * 0.7}
                width={fontSize * 0.7}
              />
            ) : null}
          </Overlay>
        </OverlayContainer>
      </DropdownContainer>
    </>
  );
};

export default DropdownPreviewOverlayChip;
